module.exports = __webpack_public_path__ + "media/icons/czesci@2x-c8fb6a1a.png";